module.exports = __webpack_public_path__ + "img/medalla2.b416fcf2.png";